import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { map } from 'rxjs';

import { ChurnReason } from '@core/churn-flow-types';
import { filterBoolean } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';

@Injectable()
export class ChurnFlowReasonInfoboxService {
  private readonly route = inject(ActivatedRoute);
  private readonly t = injectTranslate();

  public getReasonInfoboxMessage(reason: ChurnReason): Signal<string | undefined> {
    return toSignal(
      this.route.queryParams.pipe(
        filterBoolean,
        map(params => {
          if (params['display-reason-infobox'] === 'true') {
            const reasons = this.getReasons();
            const translatedReason = reasons[reason];
            return this.t('tlc.churn_flow.common.display_reason_infobox', {
              reason: translatedReason,
            });
          }

          return undefined;
        }),
      ),
    );
  }

  private getReasons(): Record<ChurnReason, string> {
    return {
      [ChurnReason.UnhelpfulSupport]: this.t(
        'tlc.churn_flow.steps.reasons.labels.insufficient_support',
      ),
      [ChurnReason.MissingFeatures]: this.t('tlc.churn_flow.steps.reasons.labels.missing_features'),
      [ChurnReason.MovingToAnotherTool]: this.t(
        'tlc.churn_flow.steps.reasons.labels.moving_to_another_tool',
      ),
      [ChurnReason.NotHiring]: this.t('tlc.churn_flow.steps.reasons.labels.not_hiring'),
      [ChurnReason.OrganizationalChanges]: this.t(
        'tlc.churn_flow.steps.reasons.labels.organizational_changes',
      ),
      [ChurnReason.Other]: this.t('tlc.churn_flow.steps.reasons.labels.other'),
      [ChurnReason.TooComplicated]: this.t('tlc.churn_flow.steps.reasons.labels.too_complicated'),
      [ChurnReason.TooExpensive]: this.t('tlc.churn_flow.steps.reasons.labels.too_expensive'),
    };
  }
}
